import React from 'react';
import PnPRefreshIPPM from '~pricing/experiments/grow_2792_pnp_refresh_v1/IPPM';
import PricingSummaryPage from '../Summary';
import useExperimentAssignment from '~pricing/hooks/useExperimentAssignment';
import useIppmStyles from './useStyles';

export default function IPPM(): JSX.Element {
  const { IPPMWrapper } = useIppmStyles();
  const { isPnPRefresh } = useExperimentAssignment();

  return (
    <div key="IPPM" data-testid="IPPM" className={IPPMWrapper}>
      {isPnPRefresh ? <PnPRefreshIPPM /> : <PricingSummaryPage />}
    </div>
  );
}
